import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse, ApiListResponse } from '../lib/response';

import { Update, UpdateNewsCount } from '../models/update';

export class UpdateService extends BaseService<Update> {
  override model = Update;
  override modelName = 'updates';
  override modelLabel = 'Updates';

  async counts(): Promise<ApiResponse<UpdateNewsCount>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/newsCount`,
    });

    return await this.requestItem(request, UpdateNewsCount);
  }

  async unread(): Promise<ApiListResponse<Update>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/recentNews`,
    });

    return await this.requestList(request, Update);
  }

  async markAsRead(): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/markNewsRead`,
    });

    return await this.requestItem(request, Update);
  }

  async markUnread(
    time: number,
  ): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/markNewsRead`,
      query: { time: time.toString() },
    });

    return await this.requestItem(request, Update);
  }
}
